// extracted by mini-css-extract-plugin
module.exports = {"radioContent":"WidgetOfferRadio_radioContent__2dlJy","big":"WidgetOfferRadio_big__1NyNU"};